import * as React from 'react';
import { Box, Stack, TablePagination, Typography } from '@mui/material';
import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import borders from 'assets/theme/base/borders';
import { useEffect, useState } from 'react';
import { RowDataType, TableMetaData } from 'types/common/common';
import { StyledTableRow } from 'component/tabel-pagination-style';
import Filter from 'component/filter';
import FilterTeam from 'pages/team/filter-team';
import { TeamByFilterListRequest } from 'types/team/team';
import { useLazyTeamByFilterListQuery } from 'store/slices/team/team';
import { API_ENDPOINT_URL } from 'constant';
import FlexibleTable from 'component/flexible-table';
import { useNavigate } from 'react-router-dom';

export const initialListData: TeamByFilterListRequest = {
    page: 1,
    pageSize: 10,
    sort: 'createdat',
};

const defaultTableStaffDataList: TableMetaData[] = [
    {
        key: 'img',
        position: 1,
        title: 'Team Avatar',
        isSortable: false,
    },
    {
        key: 'title',
        position: 2,
        title: 'Title',
        isSortable: true,
    },

    {
        key: 'teamScore',
        position: 3,
        title: 'Team Score',
        isSortable: false,
    },

    {
        key: 'teamType',
        position: 4,
        title: 'Team Type',
        isSortable: false,
    },
    {
        key: 'statusteam',
        position: 5,
        title: 'Status Team',
        isSortable: false,
    },
    {
        key: 'teamMemberCount',
        position: 6,
        title: 'User Count ',
        isSortable: false,
    },
    {
        key: 'createdat',
        position: 7,
        title: 'Creation Data',
        isSortable: true,
        type: 'date',
        format: 'DD.MM.YYYY HH:mm',
    },
];

const Team: React.FC = () => {
    const [tableMetaDataList, setTableMetaDataList] = useState<TableMetaData[]>(
        defaultTableStaffDataList,
    );
    const [dataTeamRequestList, setDataTeamRequestList] =
        React.useState<TeamByFilterListRequest>(initialListData);
    const [pagesCount, setPagesCount] = useState<number>(0);
    const [page, setPage] = useState<number>(initialListData?.page);
    const [pageSize, setPageSize] = useState<number>(
        initialListData?.pageSize ?? 0,
    );
    const [sort, setSort] = useState<string>('createdat');
    const [tableData, setTableData] = useState<RowDataType[]>([]);
    const [getTeamList, { data }] = useLazyTeamByFilterListQuery();

    const navigate = useNavigate();

    const handleClickUser = (teamId: string) => {
        navigate(`/team-info/${teamId}`);
    };
    const handleFilterData = (currentPage = 0) => {
        setPage(currentPage + 1);
    };
    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setPageSize(Number(event.target.value));
        setPage(1);
    };

    useEffect(() => {
        setPagesCount(
            data && data?.data.length > 0 ? Number(data?.rowsCount) : 0,
        );
        const tableData: RowDataType[] = data
            ? data.data.map((fullInfo) => {
                  return {
                      ...fullInfo,
                      img: (
                          <>
                              {fullInfo?.id ? (
                                  <Box
                                      component="img"
                                      src={`${API_ENDPOINT_URL}/avatar/file/${fullInfo.selectedAvatarId}`}
                                      alt=""
                                      sx={{
                                          width: 60,
                                          height: 60,
                                          objectFit: 'cover',
                                          objectPosition: 'top',
                                          borderRadius:
                                              borders.borderRadius.section,
                                      }}
                                  />
                              ) : (
                                  <Typography variant="h5">-</Typography>
                              )}
                          </>
                      ),
                      rowComponent: StyledTableRow,
                      rowProps: {
                          onClick: () => handleClickUser(fullInfo.id || ''),
                      },
                  };
              })
            : [];
        setTableData(tableData);
    }, [data]);

    useEffect(() => {
        if (dataTeamRequestList) {
            getTeamList({
                ...dataTeamRequestList,
                sort: sort === '' ? initialListData.sort : sort,
                page: page,
                pageSize: pageSize,
            });
        }
    }, [dataTeamRequestList, page, pageSize, sort]);

    return (
        <>
            <Filter>
                <FilterTeam
                    setDataTeamRequestList={setDataTeamRequestList ?? undefined}
                />
            </Filter>
            <Box
                bgcolor={colors.secondary.light}
                borderRadius={borders.borderRadius.md}
                mt={pxToRem(7)}
            >
                <FlexibleTable
                    tableMetaDataList={tableMetaDataList}
                    setTableMetaDataList={setTableMetaDataList}
                    tableDataList={tableData}
                    sort={sort}
                    setSort={setSort}
                    rowClickFunction={(row) => handleClickUser(row.id)}
                />
                {pagesCount > 0 && (
                    <Stack spacing={2} alignItems={'end'}>
                        <TablePagination
                            rowsPerPageOptions={[10, 30, 50]}
                            component="div"
                            count={pagesCount}
                            rowsPerPage={pageSize}
                            page={page - 1}
                            labelRowsPerPage={'Number of rows'}
                            slotProps={{
                                select: {
                                    inputProps: {
                                        'aria-label': 'rows per page',
                                    },
                                    MenuProps: {
                                        disablePortal: true,
                                        slotProps: {
                                            paper: {
                                                sx: {
                                                    backgroundColor:
                                                        colors.secondary.main,
                                                    padding: 0,
                                                },
                                            },
                                        },
                                    },
                                    native: false,
                                },
                            }}
                            onPageChange={(_, page) => handleFilterData(page)}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Stack>
                )}
            </Box>
        </>
    );
};
export default Team;
